<template>
  <v-main id="auth">
    <v-container
      class="pa-0 align-start"
      fluid
      align-items-start
      v-bind:class="{
        bg: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <v-row class="pa-0 mt-5 mt-sm-16 mt-xl-16 mt-lg-16 mt-md-16 mb-2">
        <v-spacer></v-spacer>
        <v-col cols="10" md="5" class="center">
          <v-card
            id="auth-card"
            class="d-flex justify-center text-center rounded-xl pa-2 pt-9 pa-sm-9 pa-md-9 pa-xl-9 pa-lg-9"
            elevation="2"
          >
            <div style="width: 100%">
              <router-link :to="'/'">
                <img
                  alt="Logo"
                  width="180"
                  class="rounded-0 text-center"
                  :src="require('@/assets/svg/logo.svg')"
                />
              </router-link>
              <router-view></router-view>
            </div>
          </v-card>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'AuthLayout',
  created() {
    if (this.$route.fullPath == '/auth') {
      const basePath = window.location.toString();
      Vue.$keycloak.login({ redirectUri: basePath });
    }
  },
};
</script>
